import { render } from "./SpecificStudentListModal.vue?vue&type=template&id=ce5ce1e4"
import script from "./SpecificStudentListModal.vue?vue&type=script&lang=js"
export * from "./SpecificStudentListModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__